import { VictimExpertiseType } from 'containers/ExpertExpertise/ConcernedExpertise/typings';
import { get, isEmpty, isNil, isNull } from 'lodash';
import { getCivilJudgementByVictimExpertise } from 'containers/CourtManagerLegalProceedings/JudgementOnMerits/utils';
import { VICTIM_EXPERTISE_FIELDS } from 'containers/data-structure';
import { formatExpertisesWithExpertReport } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/utils';
import { Config } from 'containers/AppContainer/typings';
import { CIVIL_JUDGEMENT_TYPES as CIVIL_JUDGEMENT_VICTIM_TYPES } from 'containers/LawyerLegalProceedingsPage/JudgementOnMerits/constants';
import { GLOBAL_STATUS } from 'services/constants';
import { BeneficiaryType, VictimType } from 'typings/globalTypes';
import { removeWhiteSpaceFromString } from 'services/utils';
import { FEATURES } from 'features/features';
import * as featureService from 'features/fflip-helpers';

export const getResponsibilityShareByType = (
  civilJudgementAppeal: any,
  allVictimExpertises: any,
  deceasedVictims: any,
  el: any,
  civilJudgementOnMeritsForm: any,
  responsibilityRate: string = '',
) => {
  if (el[VICTIM_EXPERTISE_FIELDS.INJURY_POST_KEY] === '2') {
    const victim = deceasedVictims.find(
      (dv: any) => dv.victimId === el.victimId,
    );
    return get(victim, 'responsibilityShare');
  }
  const responsibilityShare = getResponsabilityShare(
    civilJudgementAppeal,
    allVictimExpertises,
    el,
    civilJudgementOnMeritsForm,
    responsibilityRate,
  );
  return responsibilityShare;
};

export const getResponsabilityShare = (
  civilJudgementAppeal: any,
  allVictimExpertises: VictimExpertiseType[],
  el: any,
  civilJudgementOnMeritsForm: any,
  responsibilityRate: string = '',
) => {
  let responsibilityShare = null;
  const cj = getCivilJudgementByVictimExpertise(civilJudgementAppeal, el);
  const expertises = allVictimExpertises.filter(
    (v: any) => v.victimId === el.victimId,
  );
  expertises.filter((res: any) => {
    return cj.filter(
      // eslint-disable-next-line array-callback-return
      item => {
        const found =
          civilJudgementOnMeritsForm.find(
            (el: any) => el.id === item.id && !isNil(el.id),
          ) || {};

        if (res.expertiseId === 2 && !isEmpty(item.civjacce)) {
          return (responsibilityShare = get(
            found,
            'responsibilityShare',
            get(item, 'responsibilityShare'),
          ));
        }
        if (res.expertiseId === 1 && !isEmpty(item.civjmede)) {
          return (responsibilityShare = get(
            found,
            'responsibilityShare',
            get(item, 'responsibilityShare'),
          ));
        }
      },
    );
  });

  return !isNull(responsibilityShare)
    ? responsibilityShare
    : responsibilityRate;
};
export const checkVictimExistanceCivilPartyById = (
  id: number,
  victims: any,
) => {
  return (
    victims &&
    id &&
    victims.map((element: { id: string }) => {
      return element.id.toString() === id.toString();
    })
  );
};

export const getAppealAddDocument = (
  civilJudgement: any,
  judgementAddDocuments: any,
  judgementAddAppeal: any,
  victimExpertises: any,
  vehicleExpertises: any,
) => {
  const jadd = [
    ...judgementAddDocuments,
    ...get(judgementAddAppeal, 'judgementAddDocuments', []),
  ];
  const formattedAdd = formatExpertisesWithExpertReport(
    jadd,
    victimExpertises,
    vehicleExpertises,
  );
  return (
    formattedAdd.find(
      (item: any) => item.id === get(civilJudgement, 'judgementAddDocumentId'),
    ) || {}
  );
};
export const isCivilJudgementVictimSubstantive = (
  civilJudgementVictimReason: Config[] = [],
  victim: VictimType,
  civilJudgementVictims: any = [],
) => {
  const civjvm =
    civilJudgementVictims.find(
      (item: any) =>
        item?.victimId === get(victim, 'victimId') &&
        !get(item, 'isDeleted', false),
    ) || {};
  return isSubstantiveRejection(
    civilJudgementVictimReason,
    get(civjvm, 'reasonId'),
  );
};
export const isSubstantiveRejection = (
  civilJudgementVictimReason: Config[] = [],
  reasonId: any,
) => {
  const civjvmReason =
    civilJudgementVictimReason.find(
      (item: any) => item.id === Number(reasonId),
    ) || {};
  return (
    get(civjvmReason, 'type', '') ===
    CIVIL_JUDGEMENT_VICTIM_TYPES.SUBSTANTIVE_REJECTION
  );
};
export const isFormRejection = (
  civilJudgementVictimReason: Config[] = [],
  reasonId: any,
) => {
  const civjvmReason =
    civilJudgementVictimReason.find(
      (item: any) => item.id === Number(reasonId),
    ) || {};
  return (
    get(civjvmReason, 'type', '') ===
    CIVIL_JUDGEMENT_VICTIM_TYPES.FORM_REJECTION
  );
};
export const isNextOfKinsSubstantive = (
  beneficiaries: any = [],
  civilJudgementVictimReason: Config[] = [],
) => {
  return (
    !isEmpty(beneficiaries) &&
    beneficiaries.every(
      (nextOfKin: any) =>
        isSubstantiveRejection(
          civilJudgementVictimReason,
          get(nextOfKin, 'beneficiaryWithoutCompensation.reasonId', null),
        ) && !get(nextOfKin, 'beneficiaryWithoutCompensation.isDeleted', false),
    )
  );
};
export const isNextOfKinsWithFormRejection = (
  beneficiaries: any[] = [],
  civilJudgementVictimReason: Config[] = [],
) => {
  return (
    !isEmpty(beneficiaries) &&
    beneficiaries.some(
      (nextOfKin: any) =>
        isFormRejection(
          civilJudgementVictimReason,
          get(nextOfKin, 'beneficiaryWithoutCompensation.reasonId', null),
        ) && !get(nextOfKin, 'beneficiaryWithoutCompensation.isDeleted', false),
    ) &&
    beneficiaries.every(
      (nextOfKin: any) =>
        !isEmpty(get(nextOfKin, 'beneficiaryWithoutCompensation', {})) &&
        !get(nextOfKin, 'beneficiaryWithoutCompensation.isDeleted', false),
    )
  );
};
export const getSubstantiveWithoutCompensation = (
  civilJudgementVictimReason: Config[] = [],
  civilJudgementVictims: any = [],
) => {
  const substantiveRejectionIds = civilJudgementVictimReason
    .filter(
      (item: any) =>
        item?.type === CIVIL_JUDGEMENT_VICTIM_TYPES.SUBSTANTIVE_REJECTION,
    )
    .map(reason => reason.id);

  return civilJudgementVictims.filter(
    (item: any) =>
      substantiveRejectionIds.includes(item.reasonId) &&
      !get(item, 'expertiseJudgementAddDocumentId'),
  );
};
export const isExpertReportWithoutDecision = (expertiseReport: any) => {
  return (
    !!get(expertiseReport, 'victimExpertises', []).find(
      (el: any) =>
        el.status !== GLOBAL_STATUS.VALIDATED &&
        el.status !== GLOBAL_STATUS.CONTESTED,
    ) ||
    !!get(expertiseReport, 'vehiculeExpertises', []).find(
      (el: any) =>
        el.status !== GLOBAL_STATUS.VALIDATED &&
        el.status !== GLOBAL_STATUS.CONTESTED,
    )
  );
};

export const formatNextOfKins = (
  beneficiaries: BeneficiaryType[],
  sharedResponsability: string,
) => {
  return beneficiaries.map((el: BeneficiaryType) => {
    return {
      victimKey: get(el, 'victimKey'),
      ayantDroit: {
        fullName: `${removeWhiteSpaceFromString(
          el.firstName,
        )} ${removeWhiteSpaceFromString(el.lastName)}`,
        qualityCode: Number(el.beneficiaryType),
        age: Number(el.age),
        birthDate: el?.dateOfBirth,
        funeralFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
          ? el.funeralFees
          : !isNil(el.funeralFees) &&
            !!Number(sharedResponsability) &&
            Number(sharedResponsability) > 0
          ? parseFloat(
              String(el.funeralFees / (Number(sharedResponsability) / 100)),
            ).toFixed(2)
          : el.funeralFees,
        medicalFees: featureService.hasFeature(FEATURES.NEW_LAW_DAHIR)
          ? el?.medicalFees
          : !isNil(el?.medicalFees) &&
            !!Number(sharedResponsability) &&
            Number(sharedResponsability) > 0
          ? parseFloat(
              String(el?.medicalFees / (Number(sharedResponsability) / 100)),
            ).toFixed(2)
          : el?.medicalFees,
        handicapIndicator: el.handicapIndicator ? 'Y' : 'N',
        dependentIndicator: el.dependentIndicator ? 'Y' : 'N',
        nextOfKinKey: !isNil(get(el, 'nextOfKinKey'))
          ? get(el, 'nextOfKinKey')
          : undefined,
      },
    };
  });
};
